import _defineProperty from "/home/runner/work/hunter/hunter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
var matchName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
var iconDefaults = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16,
  rotate: 0,
  vFlip: false,
  hFlip: false
});

function fullIcon(data) {
  return _objectSpread(_objectSpread({}, iconDefaults), data);
}

function mergeIconData(icon, alias) {
  var result = _objectSpread({}, icon);

  for (var key in iconDefaults) {
    var prop = key;

    if (alias[prop] !== void 0) {
      var value = alias[prop];

      if (result[prop] === void 0) {
        result[prop] = value;
        continue;
      }

      switch (prop) {
        case "rotate":
          result[prop] = (result[prop] + value) % 4;
          break;

        case "hFlip":
        case "vFlip":
          result[prop] = value !== result[prop];
          break;

        default:
          result[prop] = value;
      }
    }
  }

  return result;
}

function getIconData(data, name) {
  var full = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  function getIcon(name2, iteration) {
    if (data.icons[name2] !== void 0) {
      return Object.assign({}, data.icons[name2]);
    }

    if (iteration > 5) {
      return null;
    }

    var aliases = data.aliases;

    if (aliases && aliases[name2] !== void 0) {
      var item = aliases[name2];
      var result2 = getIcon(item.parent, iteration + 1);

      if (result2) {
        return mergeIconData(result2, item);
      }

      return result2;
    }

    var chars = data.chars;

    if (!iteration && chars && chars[name2] !== void 0) {
      return getIcon(chars[name2], iteration + 1);
    }

    return null;
  }

  var result = getIcon(name, 0);

  if (result) {
    for (var key in iconDefaults) {
      if (result[key] === void 0 && data[key] !== void 0) {
        result[key] = data[key];
      }
    }
  }

  return result && full ? fullIcon(result) : result;
}

function isVariation(item) {
  for (var key in iconDefaults) {
    if (item[key] !== void 0) {
      return true;
    }
  }

  return false;
}

function parseIconSet(data, callback, options) {
  options = options || {};
  var names = [];

  if (typeof data !== "object" || typeof data.icons !== "object") {
    return names;
  }

  if (data.not_found instanceof Array) {
    data.not_found.forEach(function (name) {
      callback(name, null);
      names.push(name);
    });
  }

  var icons = data.icons;
  Object.keys(icons).forEach(function (name) {
    var iconData = getIconData(data, name, true);

    if (iconData) {
      callback(name, iconData);
      names.push(name);
    }
  });
  var parseAliases = options.aliases || "all";

  if (parseAliases !== "none" && typeof data.aliases === "object") {
    var aliases = data.aliases;
    Object.keys(aliases).forEach(function (name) {
      if (parseAliases === "variations" && isVariation(aliases[name])) {
        return;
      }

      var iconData = getIconData(data, name, true);

      if (iconData) {
        callback(name, iconData);
        names.push(name);
      }
    });
  }

  return names;
}

var optionalProperties = {
  provider: "string",
  aliases: "object",
  not_found: "object"
};

for (var prop in iconDefaults) {
  optionalProperties[prop] = typeof iconDefaults[prop];
}

function quicklyValidateIconSet(obj) {
  if (typeof obj !== "object" || obj === null) {
    return null;
  }

  var data = obj;

  if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") {
    return null;
  }

  for (var _prop in optionalProperties) {
    if (obj[_prop] !== void 0 && typeof obj[_prop] !== optionalProperties[_prop]) {
      return null;
    }
  }

  var icons = data.icons;

  for (var name in icons) {
    var icon = icons[name];

    if (!name.match(matchName) || typeof icon.body !== "string") {
      return null;
    }

    for (var _prop2 in iconDefaults) {
      if (icon[_prop2] !== void 0 && typeof icon[_prop2] !== typeof iconDefaults[_prop2]) {
        return null;
      }
    }
  }

  var aliases = data.aliases;

  if (aliases) {
    for (var _name in aliases) {
      var _icon = aliases[_name];
      var parent = _icon.parent;

      if (!_name.match(matchName) || typeof parent !== "string" || !icons[parent] && !aliases[parent]) {
        return null;
      }

      for (var _prop3 in iconDefaults) {
        if (_icon[_prop3] !== void 0 && typeof _icon[_prop3] !== typeof iconDefaults[_prop3]) {
          return null;
        }
      }
    }
  }

  return data;
}

var defaults = Object.freeze({
  inline: false,
  width: null,
  height: null,
  hAlign: "center",
  vAlign: "middle",
  slice: false,
  hFlip: false,
  vFlip: false,
  rotate: 0
});

function mergeCustomisations(defaults2, item) {
  var result = {};

  for (var key in defaults2) {
    var attr = key;
    result[attr] = defaults2[attr];

    if (item[attr] === void 0) {
      continue;
    }

    var value = item[attr];

    switch (attr) {
      case "inline":
      case "slice":
        if (typeof value === "boolean") {
          result[attr] = value;
        }

        break;

      case "hFlip":
      case "vFlip":
        if (value === true) {
          result[attr] = !result[attr];
        }

        break;

      case "hAlign":
      case "vAlign":
        if (typeof value === "string" && value !== "") {
          result[attr] = value;
        }

        break;

      case "width":
      case "height":
        if (typeof value === "string" && value !== "" || typeof value === "number" && value || value === null) {
          result[attr] = value;
        }

        break;

      case "rotate":
        if (typeof value === "number") {
          result[attr] += value;
        }

        break;
    }
  }

  return result;
}

var separator = /[\s,]+/;

function flipFromString(custom, flip) {
  flip.split(separator).forEach(function (str) {
    var value = str.trim();

    switch (value) {
      case "horizontal":
        custom.hFlip = true;
        break;

      case "vertical":
        custom.vFlip = true;
        break;
    }
  });
}

function alignmentFromString(custom, align) {
  align.split(separator).forEach(function (str) {
    var value = str.trim();

    switch (value) {
      case "left":
      case "center":
      case "right":
        custom.hAlign = value;
        break;

      case "top":
      case "middle":
      case "bottom":
        custom.vAlign = value;
        break;

      case "slice":
      case "crop":
        custom.slice = true;
        break;

      case "meet":
        custom.slice = false;
    }
  });
}

function rotateFromString(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var units = value.replace(/^-?[0-9.]*/, "");

  function cleanup(value2) {
    while (value2 < 0) {
      value2 += 4;
    }

    return value2 % 4;
  }

  if (units === "") {
    var num = parseInt(value);
    return isNaN(num) ? 0 : cleanup(num);
  } else if (units !== value) {
    var split = 0;

    switch (units) {
      case "%":
        split = 25;
        break;

      case "deg":
        split = 90;
    }

    if (split) {
      var _num = parseFloat(value.slice(0, value.length - units.length));

      if (isNaN(_num)) {
        return 0;
      }

      _num = _num / split;
      return _num % 1 === 0 ? cleanup(_num) : 0;
    }
  }

  return defaultValue;
}

var unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
var unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;

function calculateSize(size, ratio, precision) {
  if (ratio === 1) {
    return size;
  }

  precision = precision === void 0 ? 100 : precision;

  if (typeof size === "number") {
    return Math.ceil(size * ratio * precision) / precision;
  }

  if (typeof size !== "string") {
    return size;
  }

  var oldParts = size.split(unitsSplit);

  if (oldParts === null || !oldParts.length) {
    return size;
  }

  var newParts = [];
  var code = oldParts.shift();
  var isNumber = unitsTest.test(code);

  while (true) {
    if (isNumber) {
      var num = parseFloat(code);

      if (isNaN(num)) {
        newParts.push(code);
      } else {
        newParts.push(Math.ceil(num * ratio * precision) / precision);
      }
    } else {
      newParts.push(code);
    }

    code = oldParts.shift();

    if (code === void 0) {
      return newParts.join("");
    }

    isNumber = !isNumber;
  }
}

function preserveAspectRatio(props) {
  var result = "";

  switch (props.hAlign) {
    case "left":
      result += "xMin";
      break;

    case "right":
      result += "xMax";
      break;

    default:
      result += "xMid";
  }

  switch (props.vAlign) {
    case "top":
      result += "YMin";
      break;

    case "bottom":
      result += "YMax";
      break;

    default:
      result += "YMid";
  }

  result += props.slice ? " slice" : " meet";
  return result;
}

function iconToSVG(icon, customisations) {
  var box = {
    left: icon.left,
    top: icon.top,
    width: icon.width,
    height: icon.height
  };
  var body = icon.body;
  [icon, customisations].forEach(function (props) {
    var transformations = [];
    var hFlip = props.hFlip;
    var vFlip = props.vFlip;
    var rotation = props.rotate;

    if (hFlip) {
      if (vFlip) {
        rotation += 2;
      } else {
        transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
        transformations.push("scale(-1 1)");
        box.top = box.left = 0;
      }
    } else if (vFlip) {
      transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
      transformations.push("scale(1 -1)");
      box.top = box.left = 0;
    }

    var tempValue;

    if (rotation < 0) {
      rotation -= Math.floor(rotation / 4) * 4;
    }

    rotation = rotation % 4;

    switch (rotation) {
      case 1:
        tempValue = box.height / 2 + box.top;
        transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
        break;

      case 2:
        transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
        break;

      case 3:
        tempValue = box.width / 2 + box.left;
        transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
        break;
    }

    if (rotation % 2 === 1) {
      if (box.left !== 0 || box.top !== 0) {
        tempValue = box.left;
        box.left = box.top;
        box.top = tempValue;
      }

      if (box.width !== box.height) {
        tempValue = box.width;
        box.width = box.height;
        box.height = tempValue;
      }
    }

    if (transformations.length) {
      body = '<g transform="' + transformations.join(" ") + '">' + body + "</g>";
    }
  });
  var width, height;

  if (customisations.width === null && customisations.height === null) {
    height = "1em";
    width = calculateSize(height, box.width / box.height);
  } else if (customisations.width !== null && customisations.height !== null) {
    width = customisations.width;
    height = customisations.height;
  } else if (customisations.height !== null) {
    height = customisations.height;
    width = calculateSize(height, box.width / box.height);
  } else {
    width = customisations.width;
    height = calculateSize(width, box.height / box.width);
  }

  if (width === "auto") {
    width = box.width;
  }

  if (height === "auto") {
    height = box.height;
  }

  width = typeof width === "string" ? width : width.toString() + "";
  height = typeof height === "string" ? height : height.toString() + "";
  var result = {
    attributes: {
      width: width,
      height: height,
      preserveAspectRatio: preserveAspectRatio(customisations),
      viewBox: box.left.toString() + " " + box.top.toString() + " " + box.width.toString() + " " + box.height.toString()
    },
    body: body
  };

  if (customisations.inline) {
    result.inline = true;
  }

  return result;
}

var regex = /\sid="(\S+)"/g;
var randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
var counter = 0;

function replaceIDs(body) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : randomPrefix;
  var ids = [];
  var match;

  while (match = regex.exec(body)) {
    ids.push(match[1]);
  }

  if (!ids.length) {
    return body;
  }

  ids.forEach(function (id) {
    var newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
    var escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    body = body.replace(new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + "$3");
  });
  return body;
}
/**
 * Default SVG attributes
 */


var svgDefaults = {
  'xmlns': 'http://www.w3.org/2000/svg',
  'xmlnsXlink': 'http://www.w3.org/1999/xlink',
  'aria-hidden': true,
  'role': 'img',
  'style': {} // Include style if it isn't set to add verticalAlign later

};
/**
 * Default values for customisations for inline icon
 */

var inlineDefaults = _objectSpread(_objectSpread({}, defaults), {}, {
  inline: true
});
/**
 * Render icon
 */


var render = function render( // Icon must be validated before calling this function
icon, // Partial properties
props, // True if icon should have vertical-align added
inline, // Optional reference for SVG, extracted by React.forwardRef()
ref) {
  // Get default properties
  var defaultProps = inline ? inlineDefaults : defaults; // Get all customisations

  var customisations = mergeCustomisations(defaultProps, props); // Create style

  var style = typeof props.style === 'object' && props.style !== null ? props.style : {}; // Create SVG component properties

  var componentProps = _objectSpread(_objectSpread({}, svgDefaults), {}, {
    ref: ref,
    style: style
  }); // Get element properties


  for (var key in props) {
    var value = props[key];

    if (value === void 0) {
      continue;
    }

    switch (key) {
      // Properties to ignore
      case 'icon':
      case 'style':
      case 'children':
      case 'onLoad':
      case '_ref':
      case '_inline':
        break;
      // Boolean attributes

      case 'inline':
      case 'hFlip':
      case 'vFlip':
        customisations[key] = value === true || value === 'true' || value === 1;
        break;
      // Flip as string: 'horizontal,vertical'

      case 'flip':
        if (typeof value === 'string') {
          flipFromString(customisations, value);
        }

        break;
      // Alignment as string

      case 'align':
        if (typeof value === 'string') {
          alignmentFromString(customisations, value);
        }

        break;
      // Color: copy to style

      case 'color':
        style.color = value;
        break;
      // Rotation as string

      case 'rotate':
        if (typeof value === 'string') {
          customisations[key] = rotateFromString(value);
        } else if (typeof value === 'number') {
          customisations[key] = value;
        }

        break;
      // Remove aria-hidden

      case 'ariaHidden':
      case 'aria-hidden':
        if (value !== true && value !== 'true') {
          delete componentProps['aria-hidden'];
        }

        break;
      // Copy missing property if it does not exist in customisations

      default:
        if (defaultProps[key] === void 0) {
          componentProps[key] = value;
        }

    }
  } // Generate icon


  var item = iconToSVG(icon, customisations); // Counter for ids based on "id" property to render icons consistently on server and client

  var localCounter = 0;
  var id = props.id;

  if (typeof id === 'string') {
    // Convert '-' to '_' to avoid errors in animations
    id = id.replace(/-/g, '_');
  } // Add icon stuff


  componentProps.dangerouslySetInnerHTML = {
    __html: replaceIDs(item.body, id ? function () {
      return id + 'ID' + localCounter++;
    } : 'iconifyReact')
  };

  for (var _key in item.attributes) {
    componentProps[_key] = item.attributes[_key];
  }

  if (item.inline && style.verticalAlign === void 0) {
    style.verticalAlign = '-0.125em';
  }

  return React.createElement('svg', componentProps);
};
/**
 * Storage for icons referred by name
 */


var storage = Object.create(null);
/**
 * Generate icon
 */

function component(props, inline, ref) {
  // Split properties
  var icon = typeof props.icon === 'string' ? storage[props.icon] : typeof props.icon === 'object' ? fullIcon(props.icon) : null; // Validate icon object

  if (icon === null || typeof icon !== 'object' || typeof icon.body !== 'string') {
    return props.children ? props.children : React.createElement('span', {});
  } // Valid icon: render it


  return render(icon, props, inline, ref);
}
/**
 * Block icon
 *
 * @param props - Component properties
 */


var Icon = React.forwardRef(function Icon(props, ref) {
  return component(props, false, ref);
});
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */

var InlineIcon = React.forwardRef(function InlineIcon(props, ref) {
  return component(props, true, ref);
});
/**
 * Add icon to storage, allowing to call it by name
 *
 * @param name
 * @param data
 */

function addIcon(name, data) {
  storage[name] = fullIcon(data);
}
/**
 * Add collection to storage, allowing to call icons by name
 *
 * @param data Icon set
 * @param prefix Optional prefix to add to icon names, true (default) if prefix from icon set should be used.
 */


function addCollection(data, prefix) {
  var iconPrefix = typeof prefix === 'string' ? prefix : prefix !== false && typeof data.prefix === 'string' ? data.prefix + ':' : '';
  quicklyValidateIconSet(data) && parseIconSet(data, function (name, icon) {
    if (icon) {
      storage[iconPrefix + name] = icon;
    }
  });
}

export { Icon, InlineIcon, addCollection, addIcon };